type Job = () => void;

class FrameDOM {
  private measureQueue: Job[] = [];
  private mutateQueue: Job[] = [];
  private scheduled = false;

  public measure(fn: Job): void {
    this.measureQueue.push(fn);
    this.schedule();
  }

  public mutate(fn: Job): void {
    this.mutateQueue.push(fn);
    this.schedule();
  }

  private schedule(): void {
    if (this.scheduled) {
      return;
    }

    this.scheduled = true;
    requestAnimationFrame(() => {
      const mQueue = this.measureQueue;
      this.measureQueue = [];
      for (let i = 0; i < mQueue.length; i++) {
        try {
          mQueue[i]();
        } catch (e) {
          console.error("Error in frameDOM measure task:", e);
        }
      }

      const wQueue = this.mutateQueue;
      this.mutateQueue = [];
      for (let i = 0; i < wQueue.length; i++) {
        try {
          wQueue[i]();
        } catch (e) {
          console.error("Error in frameDOM mutate task:", e);
        }
      }

      this.scheduled = false;
    });
  }
}

export const frameDOM = new FrameDOM();
